import { useProductStore } from '../../../../store/useProduct';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faUsers } from '@fortawesome/free-solid-svg-icons';

/**
 * @author taulmax
 * @createDate 2024.10.30
 * @description 상품 상세 페이지 - 서비스
 */
const PDService = () => {
  const { productDetail } = useProductStore();

  if (!productDetail) {
    return (
      <div className="animate-pulse">
        <div className="h-4 w-20 bg-gray-200 rounded mb-3"></div>
        <div className="h-8 w-32 bg-gray-200 rounded"></div>
      </div>
    );
  }

  const serviceConfig: { [key: number]: { text: string; icon: any; bgClass: string; iconClass: string } } = {
    1: {
      text: '개별 서비스 (1인)',
      icon: faUser,
      bgClass: 'bg-blue-100',
      iconClass: 'text-blue-600'
    },
    2: {
      text: '동반 서비스 (2인)',
      icon: faUsers,
      bgClass: 'bg-purple-100',
      iconClass: 'text-purple-600'
    }
  };

  const service = serviceConfig[productDetail.custInfoCount] || {
    text: '알 수 없음',
    icon: faUser,
    bgClass: 'bg-gray-100',
    iconClass: 'text-gray-600'
  };

  return (
    <div className="inline-flex items-center gap-2">
      <div className={`w-6 h-6 rounded ${service.bgClass} flex items-center justify-center`}>
        <FontAwesomeIcon icon={service.icon} className={`${service.iconClass} text-xs`} />
      </div>
      <span className="text-sm text-gray-700">
        {service.text}
      </span>
    </div>
  );
};

export default PDService;
